import Link from "next/link";

export default function CtaSection() {
  return (
    <section
      className="py-24 px-5 md:px-20 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, rgba(15,23,42,1) 0%, rgba(36,97,230,1) 50%, rgba(15,23,42,1) 100%)",
        position: "relative",
      }}
    >
      {/* Decorative blurred circles */}
      <div className="absolute inset-0 pointer-events-none" style={{ opacity: 0.1 }}>
        <div
          className="bg-[#3b82f6] rounded-full w-96 h-96 absolute left-0 top-0"
          style={{ filter: "blur(32px)" }}
        />
        <div
          className="bg-[#3b82f6] rounded-full w-96 h-96 absolute right-0 bottom-0"
          style={{ filter: "blur(32px)" }}
        />
      </div>

      <div className="max-w-4xl mx-auto px-0 md:px-8 flex flex-col gap-6 items-center justify-center">
        {/* Heading */}
        <h2 className="text-white text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold">
          Ready to Modernize Your
          <br />
          Loan Recovery Operations?
        </h2>

        {/* Subtext */}
        <p className="text-[#e9d5ff] text-center font-normal text-lg md:text-xl leading-relaxed">
          See how DebtPulse can improve your recovery rates while keeping you compliant.
        </p>

        {/* CTA Buttons */}
        <div className="pt-4 flex flex-col sm:flex-row gap-4 items-center justify-center w-full">
          <Link
            href="/contact?ref=debtpulse"
            className="bg-white rounded-lg py-5 px-10 flex flex-row gap-2 items-center justify-center"
          >
            <span className="text-[#111827] text-center font-semibold text-lg leading-7">
              Book a Live Demo
            </span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.1667 6.66797L17.5 10.0013M17.5 10.0013L14.1667 13.3346M17.5 10.0013H2.5" stroke="#111827" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>

          <a
            href="https://debtpulse.cloudastra.co/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 rounded-lg border border-white/20 py-5 px-10 flex items-center justify-center"
            style={{ backdropFilter: "blur(2px)" }}
          >
            <span className="text-white text-center font-semibold text-lg leading-7">
              Explore DebtPulse
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
